import { Alert, Button, Descriptions, Divider, Form, Input, message, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axiosInstance from "../../common/api";
import dayjs from "dayjs";

const absMonths = 3;
const absThreshold = 0.05;

export default function () {
    const { processId } = useParams();
    const [data, setData] = useState({});
    const navigate = useNavigate();
    const [sp, setSP] = useSearchParams();
    const [absenteeism, setAbsenteeism] = useState({});
    const [form] = Form.useForm();

    useEffect(() => {
        axiosInstance
            .get(`leaveRequest/${processId}/evaluateTask`)
            .then(({ data }) => setData(data));
    }, []);

    useEffect(() => {
        if (data.variables?.employee) {
            const now = dayjs();
            axiosInstance
                .get("absenteeism", {
                    params: {
                        employee: data.variables.employee.id,
                        startDate: now.subtract(absMonths, "month").format("YYYY-MM-DD"),
                        endDate: now.format("YYYY-MM-DD"),
                    },
                })
                .then(({ data }) => setAbsenteeism(data[0]));
        }
    }, [data]);

    const onFinish = (form) => {
        axiosInstance
            .post("leaveRequest/evaluate", {
                taskId: data.id,
                approved: form.approved,
                notes: form.notes,
            })
            .then(() => {
                if (sp.get("goBack") === "true") navigate(-1);
                else navigate("/tasks", { replace: true });
                message.success("Operazione eseguita con successo")
            });
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 24 }}>
            <Descriptions
                title="Richiesta di assenza"
                layout="vertical"
                colon={false}
                size="small"
                column={{ xs: 1, sm: 1, md: 1, lg: 3, xl: 3, xxl: 3 }}
            >
                <Descriptions.Item label="Dipendente">
                    {data.variables?.employee?.firstName} {data.variables?.employee?.lastName}
                </Descriptions.Item>

                <Descriptions.Item label="Tipologia assenza" span={2}>
                    {data.variables?.justificationType?.name}
                </Descriptions.Item>
                <Descriptions.Item label="Data inizio">
                    {dayjs(data.variables?.startDate).format("DD/MM/YYYY")}
                </Descriptions.Item>
                <Descriptions.Item label="Data fine">
                    {dayjs(data.variables?.endDate).format("DD/MM/YYYY")}
                </Descriptions.Item>
                {data.variables?.hours > 0 && (
                    <Descriptions.Item label="Ore richieste">
                        {data.variables?.hours}
                    </Descriptions.Item>
                )}
                {data.variables?.requestReason && (
                    <Descriptions.Item label="Motivazione" span={3}>
                        {data.variables?.requestReason}
                    </Descriptions.Item>
                )}
            </Descriptions>
            <Divider orientation="left" style={{ marginTop: 60 }}>
                Azione
            </Divider>

            {(absenteeism?.rate ?? 0) > absThreshold && (
                <div>
                    <Alert
                        showIcon
                        type="warning"
                        message="Attenzione!!"
                        description={
                            <>
                                Tasso di assenteismo del richiedente (giorni di assenza / giorni
                                lavorativi) negli ultimi {absMonths} mesi:{" "}
                                <b>
                                    {((absenteeism?.rate ?? 0) * 100).toLocaleString("it-IT", {
                                        maximumFractionDigits: 2,
                                    })}
                                    %
                                </b>
                            </>
                        }
                    />
                </div>
            )}
            <Form layout="vertical" onFinish={onFinish} form={form}>
                <Form.Item label="Note" name="notes">
                    <Input.TextArea rows={3} placeholder="Es. motivo rifiuto"></Input.TextArea>
                </Form.Item>
                <Form.Item style={{ textAlign: "end" }} name="approved">
                    <Space wrap size={48}>
                        <Button
                            style={{ width: 150 }}
                            htmlType="submit"
                            size="large"
                            color="danger"
                            variant="solid"
                            onClick={() => form.setFieldValue("approved", false)}
                        >
                            Rifiuta
                        </Button>
                        <Button
                            htmlType="submit"
                            onClick={() => form.setFieldValue("approved", true)}
                            style={{ width: 150 }}
                            size="large"
                            color="green"
                            variant="solid"
                        >
                            Accetta
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    );
}
